import { articleTypeBindings } from '../constants/article-type-bindings';
import { ArticleType } from '../enums/articleType.enum';

export function getNameFromArticleType(articleType: ArticleType): string {
  return articleTypeBindings[articleType] || 'None (ask Content Manager to set one)';
}
